import React, { useState, useEffect } from "react";
import { Modal, Typography, Button } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { CloseOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { transferPatient } from "../../patientDetails/patientDetailsSlice";
import { listOrders } from "../../orders/OrdersSlice";
import { reload } from "../PatientsSlice";
import PatientDetails from "../../scheduling/components/PatientDetails";
import { SettingsDataSelect } from "../../../components/forms/AutoCompleteComponent";

const { Title } = Typography;

const TransferPatient = (props) => {
  const { visible, hide } = props;
  const [selected, setSelected] = useState(null);
  const assignLoading = useSelector(
    (state) => state.pendingActions["transferPatient/transfer"]
  );
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );
  const [modal, contextHolder] = Modal.useModal();

  const intl = useIntl();
  const dispatch = useDispatch();

  const onChange = (value) => {
    setSelected(value);
  };

  const onTransfer = async () => {
    const listParams = {
      current: 1,
      filter: {
        freeText: null,
      },
      patientId: activePatient.id,
    };
    const action = await dispatch(listOrders(listParams));
    const isEitherNullOrFuture = action.payload.data?.items.some((item) => {
      if (item.effective_to === null) return true;
      const currentDate = new Date();
      const effectiveDate = new Date(item.effective_to);
      return effectiveDate > currentDate;
    });

    if (isEitherNullOrFuture) {
      const title = intl.formatMessage({
        id: "app.patients.transferPatientWarningTitle",
      });
      const content = intl.formatMessage({
        id: "app.patients.transferPatientWarningContent",
      });
      modal.confirm({
        title: title,
        icon: <ExclamationCircleOutlined />,
        content: content,
        onOk() {
          return onConfirm();
        },
        onCancel() {},
      });
    } else {
      onConfirm();
    }
  };

  const onConfirm = async () => {
    const params = {
      currentBranchId: activePatient.branch_id,
      branchId: selected,
      patientId: activePatient.id,
    };
    const action = await dispatch(transferPatient(params));
    if (!action.error) {
      dispatch(reload());
      hide();
    }
  };

  const onHide = () => {
    setSelected(null);
    hide();
  };

  return (
    <>
      {contextHolder}
      <Modal
        closable={false}
        maskClosable={false}
        open={visible}
        footer={null}
        onCancel={onHide}
        title={null}
        width={"fit-content"}
        styles={{
          body: {
            padding: "0px 100px 40px 100px",
          },
        }}
        destroyOnClose={true}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div className="header" style={{ height: "40px" }}>
            <Button
              style={{ position: "absolute", left: 10, top: 10 }}
              className="closeBtn"
              type="text"
              shape="circle"
              icon={<CloseOutlined />}
              onClick={onHide}
            />
          </div>
          <Title
            style={{
              fontSize: "30px",
              fontWeight: 500,
              lineHeight: 1.27,
              color: "rgba(0, 0, 0, 0.85)",
              margin: "13px 0 20px 0 ",
              textAlign: "center",
            }}
          >
            {intl.formatMessage({
              id: "app.patients.transferPatientTitle",
            })}
          </Title>
          <div style={{ height: "70px" }}>
            {activePatient && activePatient.id && (
              <PatientDetails record={activePatient} />
            )}
          </div>
          <SettingsDataSelect
            style={{ width: "200px" }}
            onChange={onChange}
            settingsdataName={"branches"}
            type="list"
            placeholder={intl.formatMessage({
              id: "app.users.chooseBranch",
            })}
          />
          <Button
            style={{ width: "fit-content", marginTop: "20px" }}
            type="primary"
            disabled={!selected}
            onClick={onTransfer}
            loading={assignLoading}
          >
            {intl.formatMessage({
              id: "app.patients.transferPatientAction",
            })}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default TransferPatient;
